import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Button from "./Button.tsx";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface SessionExpiredModalProps {
  open: boolean;
  onClose: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onClose }) => {
  return (
    <>
      <Modal
        backdrop="static"
        centered={true}
        toggle={onClose}
        isOpen={open}
        className="rv-modal"
      >
        <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
          Session Expired
          <button
            type="button"
            className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
            onClick={onClose}
          >
            &times;
          </button>
        </ModalHeader>
        <ModalBody className="fs-5 fw-bold text-center d-block">
          Your session has expired. Please log in again.
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center align-items-center p-4">
          <div className="d-flex flex-row gap-3">
            <Button
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              onClick={onClose}
            >
              <i className="ri-logout-box-line ri-xl label-icon align-middle me-1"></i>
              {/* <RiPlayLargeLine size={16} /> */}
              <span className="ps-3 px-2 ms-2 me-1 modal-btn">Login Again</span>
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
    // <Dialog open={open} onClose={onClose} className="p-5">
    //   <DialogTitle>Session Expired</DialogTitle>
    //   <DialogContent>Your session has expired. Please log in again.</DialogContent>
    //   <DialogActions>
    //     <Button onClick={onClose} >
    //       Login Again
    //     </Button>
    //   </DialogActions>
    // </Dialog>
  );
};

export default SessionExpiredModal;
